

const authtoken = localStorage.getItem("userToken");

export const headers = {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + authtoken
}